<template>
  <div class="reporting-wrapper">

    <!-- ── Mode legacy : bandeau avertissement (switch masqué en prod) ────────── -->
    <div v-if="!useV2 && showSwitch" class="rv-banner">
      <i class="material-icons rv-banner__icon">history</i>
      <span class="rv-banner__text">{{ $t('dash.reporting.legacy_banner_text') }}</span>
      <button class="rv-banner__btn" @click="switchVersion('2')">
        {{ $t('dash.reporting.switch_to_v2') }}
        <i class="material-icons">arrow_forward</i>
      </button>
    </div>

    <!-- ── Mode V2 : barre discrète (switch masqué en prod) ────────────────── -->
    <div v-if="useV2 && showSwitch" class="rv-topbar">
      <button class="rv-topbar__btn" @click="switchVersion('1')">
        <i class="material-icons">history</i>
        {{ $t('dash.reporting.switch_to_legacy') }}
      </button>
    </div>

    <ReportingMain v-if="useV2" />
    <ReportingLegacy v-else />

  </div>
</template>

<script>
import ReportingLegacy from './ReportingLegacy'
import ReportingMain from '../reporting-web/ReportingMain'

export default {
  name: 'Reporting',
  components: { ReportingLegacy, ReportingMain },

  data() {
    const envVersion = process.env.VUE_APP_REPORTING_VERSION || '1'
    const switchEnabled = envVersion !== '1'
    // En mode switch désactivé (env=1) : toujours legacy, localStorage ignoré
    // En mode switch activé (env=2) : V2 par défaut, localStorage peut basculer vers V1
    const stored = switchEnabled ? localStorage.getItem('reportingVersion') : null
    return {
      useV2: switchEnabled ? (stored !== null ? stored !== '1' : true) : false,
      showSwitch: switchEnabled,
    }
  },

  methods: {
    switchVersion(v) {
      localStorage.setItem('reportingVersion', v)
      location.reload()
    },
  },
}
</script>

<style lang="scss" scoped>
.reporting-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
}

// ── Barre discrète V2 (haut, switch vers classique) ───────────────────────────
.rv-topbar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 5px 18px;
  border-bottom: 1px solid #f2ecf5;
  background: #fdfbfe;
  flex-shrink: 0;

  &__btn {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 3px 12px 3px 9px;
    background: transparent;
    border: 1.5px solid #e5d8e8;
    border-radius: 20px;
    color: #b08aa0;
    font-size: 11.5px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    font-family: inherit;

    .material-icons { font-size: 14px; }

    &:hover {
      border-color: #6b1f4d;
      color: #6b1f4d;
      background: rgba(107, 31, 77, 0.04);
    }
  }
}

// ── Bandeau mode legacy ───────────────────────────────────────────────────────
.rv-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 20px;
  background: linear-gradient(90deg, #fffde7 0%, #fff8e1 100%);
  border-bottom: 2px solid #ffc107;
  flex-shrink: 0;

  &__icon {
    font-size: 20px;
    color: #f59e0b;
    flex-shrink: 0;
  }

  &__text {
    flex: 1;
    font-size: 13px;
    color: #5d4000;
    font-weight: 500;
    font-family: inherit;
  }

  &__btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 7px 18px 7px 16px;
    background: #6b1f4d;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    flex-shrink: 0;
    font-family: inherit;
    box-shadow: 0 2px 8px rgba(107, 31, 77, 0.25);
    transition: background 0.2s ease, box-shadow 0.2s ease;

    .material-icons { font-size: 16px; }

    &:hover {
      background: #8b2a65;
      box-shadow: 0 4px 12px rgba(107, 31, 77, 0.35);
    }
  }
}
</style>
